/** Generated by scripts/lesson_plans/export_feed_from_lessons.py — do not edit by hand. */

const EXAMPLES = {
  "roots-cajun-regions-roots-cajun-01-overview-kp-1": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-01-overview-kp-2": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-01-overview-kp-3": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-01-overview-kp-4": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-01-overview-kp-5": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-01-overview-sec-1-overview": {
    "kind": "none",
    "illustrationPlan": "Overview — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-01-overview-sec-2-compared-with-appalachia": {
    "kind": "none",
    "illustrationPlan": "Compared with Appalachia — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-01-overview-sec-9-study-facts": {
    "kind": "none",
    "illustrationPlan": "Study facts — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-02-instruments-voices-i-kp-1": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-02-instruments-voices-i-kp-2": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-02-instruments-voices-i-kp-3": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-02-instruments-voices-i-kp-4": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-02-instruments-voices-i-kp-5": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-02-instruments-voices-i-sec-2-compared-with-appalachia": {
    "kind": "none",
    "illustrationPlan": "Compared with Appalachia — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-02-instruments-voices-i-sec-9-study-facts": {
    "kind": "none",
    "illustrationPlan": "Study facts — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-03-instruments-voices-ii-kp-1": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-03-instruments-voices-ii-kp-2": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-03-instruments-voices-ii-kp-3": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-03-instruments-voices-ii-kp-4": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-03-instruments-voices-ii-kp-5": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-03-instruments-voices-ii-sec-2-compared-with-appalachia": {
    "kind": "none",
    "illustrationPlan": "Compared with Appalachia — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-03-instruments-voices-ii-sec-9-study-facts": {
    "kind": "none",
    "illustrationPlan": "Study facts — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-04-genres-forms-kp-1": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-04-genres-forms-kp-2": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-04-genres-forms-kp-3": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-04-genres-forms-kp-4": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-04-genres-forms-kp-5": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-04-genres-forms-sec-2-compared-with-appalachia": {
    "kind": "none",
    "illustrationPlan": "Compared with Appalachia — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-04-genres-forms-sec-9-study-facts": {
    "kind": "none",
    "illustrationPlan": "Study facts — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-05-dance-kp-1": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-05-dance-kp-2": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-05-dance-kp-3": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-05-dance-kp-4": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-05-dance-kp-5": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-05-dance-sec-2-compared-with-appalachia": {
    "kind": "none",
    "illustrationPlan": "Compared with Appalachia — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-05-dance-sec-9-study-facts": {
    "kind": "none",
    "illustrationPlan": "Study facts — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-06-history-kp-1": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-06-history-kp-2": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-06-history-kp-3": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-06-history-kp-4": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-06-history-kp-5": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-06-history-sec-2-compared-with-appalachia": {
    "kind": "none",
    "illustrationPlan": "Compared with Appalachia — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-06-history-sec-9-study-facts": {
    "kind": "none",
    "illustrationPlan": "Study facts — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-07-representative-depth-kp-1": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-07-representative-depth-kp-2": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-07-representative-depth-kp-3": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-07-representative-depth-kp-4": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-07-representative-depth-kp-5": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-07-representative-depth-sec-2-compared-with-appalachia": {
    "kind": "none",
    "illustrationPlan": "Compared with Appalachia — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-07-representative-depth-sec-9-study-facts": {
    "kind": "none",
    "illustrationPlan": "Study facts — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-08-tunes-kp-1": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-08-tunes-kp-2": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-08-tunes-kp-3": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-08-tunes-kp-4": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-08-tunes-kp-5": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-08-tunes-sec-2-compared-with-appalachia": {
    "kind": "none",
    "illustrationPlan": "Compared with Appalachia — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-08-tunes-sec-10-study-facts": {
    "kind": "none",
    "illustrationPlan": "Study facts — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-08-tunes-tune-jolie-blonde": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: Jolie Blonde — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-08-tunes-tune-allons-lafayette": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: Allons à Lafayette — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "roots-cajun-regions-roots-cajun-08-tunes-tune-cajun-standard-2": {
    "kind": "none",
    "illustrationPlan": "Roots-Cajun trad: cajun standard 2 — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  }
}

export default EXAMPLES
